// używane w widoku dla administratora: Admin-System Log

export class Syslog {
    id?: any;
    date?: Date;        // creation date
    username?: string;  // account username
    source?: string;    // name of component which generated event
    level?: string;     // possible: info/warrning/error
    info?: string;      // description
  }

export class SummarySysLog {
    events_info?: number;        // creation date
    events_warning?: number;  // account username
    events_error?: number;    // name of component which generated event
  }

// ****************************************************************************
// używane w widoku dla administratora: Admin-System Settings
// dla API: getDns
export class SettingsDns {
  id?: any;                 // id rekordu zarejestrowanego DNS
  dnsname?: string;         // nazwa dns
  publishers?: number[];    // tablica przypisanych publisherów do dns
  monitor?: number;         // monitorowanie działania dns 1-ok 0-zablokowany
  dnsstatus?: string;       // 'on' włączony 'off' wyłączone używanie dns
}

// dla API:registerDns, updateDns
export class SettingsDnsSingle {
  id?: any;                 // id rekordu zarejestrowanego DNS
  dnsName?: string;         // nazwa dns
  publishers?: number[];    // tablica przypisanych publisherów do dns
  dnsStatus?: string;       // 'on' włączony 'off' wyłączone używanie dns
  isDefault?: boolean;      // true jeżeli DNS jest default, jak nie to false
}
